export const respnse = {
  "data": {
    "product": {
      "id": "gid://shopify/Product/14904810733935",
      "handle": "superrev-me3d",
      "variants": {
        "edges": [
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52725369340271",
              "title": "SuperRev™ / Men’s 5 / Women’s 6",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™"
                },
                {
                  "name": "Size",
                  "value": "Men’s 5 / Women’s 6"
                }
              ],
              "material": {
                "id": "gid://shopify/Metafield/181197981811055",
                "namespace": "custom",
                "key": "material",
                "value": "gid://shopify/Metaobject/273367794031",
                "type": "metaobject_reference",
                "description": null,
                "reference": {
                  "fields": [
                    {
                      "key": "description",
                      "value": "Fits best in all footwear, including tight fitting shoes. Lightweight, responsive cushioning with a balanced feel for everyday performance.",
                      "type": "multi_line_text_field",
                      "reference": null
                    },
                    {
                      "key": "image",
                      "value": "gid://shopify/MediaImage/53772547981679",
                      "type": "file_reference",
                      "reference": {
                        "image": {
                          "url": "https://cdn.shopify.com/s/files/1/0638/5346/1687/files/SuperRev_Foam_Material.png?v=1777489323",
                          "altText": null,
                          "width": 960,
                          "height": 480
                        }
                      }
                    },
                    {
                      "key": "title",
                      "value": "SuperRev&trade; – 4.5mm thick",
                      "type": "single_line_text_field",
                      "reference": null
                    }
                  ]
                }
              }
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763782513007",
              "title": "SuperRev™ / Men’s 6 / Women’s 7",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™"
                },
                {
                  "name": "Size",
                  "value": "Men’s 6 / Women’s 7"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763782545775",
              "title": "SuperRev™ / Men’s 7 / Women’s 8",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™"
                },
                {
                  "name": "Size",
                  "value": "Men’s 7 / Women’s 8"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763782578543",
              "title": "SuperRev™ / Men’s 8 / Women’s 9",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™"
                },
                {
                  "name": "Size",
                  "value": "Men’s 8 / Women’s 9"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763782611311",
              "title": "SuperRev™ / Men’s 9 / Women’s 10",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™"
                },
                {
                  "name": "Size",
                  "value": "Men’s 9 / Women’s 10"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763782644079",
              "title": "SuperRev™ / Men’s 10 / Women’s 11",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™"
                },
                {
                  "name": "Size",
                  "value": "Men’s 10 / Women’s 11"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763782676847",
              "title": "SuperRev™ / Men’s 11 / Women’s 12",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™"
                },
                {
                  "name": "Size",
                  "value": "Men’s 11 / Women’s 12"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763782709615",
              "title": "SuperRev™ / Men’s 12 / Women’s 13",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™"
                },
                {
                  "name": "Size",
                  "value": "Men’s 12 / Women’s 13"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763782742383",
              "title": "SuperRev™ / Men’s 13 / Women’s 14",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™"
                },
                {
                  "name": "Size",
                  "value": "Men’s 13 / Women’s 14"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763782775151",
              "title": "SuperRev™ / Men’s 14 / Women’s 15",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™"
                },
                {
                  "name": "Size",
                  "value": "Men’s 14 / Women’s 15"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763782807919",
              "title": "SuperRev™ / Men’s 15 / Women’s 16",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™"
                },
                {
                  "name": "Size",
                  "value": "Men’s 15 / Women’s 16"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52725370028399",
              "title": "SuperRev™ Max / Men’s 5 / Women’s 6",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™ Max"
                },
                {
                  "name": "Size",
                  "value": "Men’s 5 / Women’s 6"
                }
              ],
              "material": {
                "id": "gid://shopify/Metafield/181197984137583",
                "namespace": "custom",
                "key": "material",
                "value": "gid://shopify/Metaobject/273367826799",
                "type": "metaobject_reference",
                "description": null,
                "reference": {
                  "fields": [
                    {
                      "key": "description",
                      "value": "Fits best in moderate to roomy fitting shoes. Maximum cushioning with higher rebound and increased underfoot protection for a more amplified ride.",
                      "type": "multi_line_text_field",
                      "reference": null
                    },
                    {
                      "key": "image",
                      "value": "gid://shopify/MediaImage/53772548014447",
                      "type": "file_reference",
                      "reference": {
                        "image": {
                          "url": "https://cdn.shopify.com/s/files/1/0638/5346/1687/files/SuperRev-Max_Foam_Material.png?v=1777489323",
                          "altText": null,
                          "width": 960,
                          "height": 480
                        }
                      }
                    },
                    {
                      "key": "title",
                      "value": "SuperRev&trade; Max – 6.5mm thick",
                      "type": "single_line_text_field",
                      "reference": null
                    }
                  ]
                }
              }
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763782840687",
              "title": "SuperRev™ Max / Men’s 6 / Women’s 7",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™ Max"
                },
                {
                  "name": "Size",
                  "value": "Men’s 6 / Women’s 7"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763782873455",
              "title": "SuperRev™ Max / Men’s 7 / Women’s 8",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™ Max"
                },
                {
                  "name": "Size",
                  "value": "Men’s 7 / Women’s 8"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763782906223",
              "title": "SuperRev™ Max / Men’s 8 / Women’s 9",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™ Max"
                },
                {
                  "name": "Size",
                  "value": "Men’s 8 / Women’s 9"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763782938991",
              "title": "SuperRev™ Max / Men’s 9 / Women’s 10",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™ Max"
                },
                {
                  "name": "Size",
                  "value": "Men’s 9 / Women’s 10"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763782971759",
              "title": "SuperRev™ Max / Men’s 10 / Women’s 11",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™ Max"
                },
                {
                  "name": "Size",
                  "value": "Men’s 10 / Women’s 11"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763783004527",
              "title": "SuperRev™ Max / Men’s 11 / Women’s 12",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™ Max"
                },
                {
                  "name": "Size",
                  "value": "Men’s 11 / Women’s 12"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763783037295",
              "title": "SuperRev™ Max / Men’s 12 / Women’s 13",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™ Max"
                },
                {
                  "name": "Size",
                  "value": "Men’s 12 / Women’s 13"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763783070063",
              "title": "SuperRev™ Max / Men’s 13 / Women’s 14",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™ Max"
                },
                {
                  "name": "Size",
                  "value": "Men’s 13 / Women’s 14"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763783102831",
              "title": "SuperRev™ Max / Men’s 14 / Women’s 15",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™ Max"
                },
                {
                  "name": "Size",
                  "value": "Men’s 14 / Women’s 15"
                }
              ],
              "material": null
            }
          },
          {
            "node": {
              "id": "gid://shopify/ProductVariant/52763783135599",
              "title": "SuperRev™ Max / Men’s 15 / Women’s 16",
              "selectedOptions": [
                {
                  "name": "Foam Package",
                  "value": "SuperRev™ Max"
                },
                {
                  "name": "Size",
                  "value": "Men’s 15 / Women’s 16"
                }
              ],
              "material": null
            }
          }
        ]
      }
    }
  },
  "extensions": {
    "cost": {
      "requestedQueryCost": 74
    }
  }
};
